(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9579],{

/***/ 51310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferTile; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88362);
/* harmony import */ var _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39519);
/* harmony import */ var _utils_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1003);
/* harmony import */ var _RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75547);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92477);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22838);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













var DISABLED_OFFER_WARNING = 'Το συγκεκριμένο προϊόν δεν είναι πλέον διαθέσιμο';
function OfferTile(_ref) {
  var _cn;

  var offer = _ref.offer,
      isHomeOffer = _ref.isHomeOffer,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var priceString = "\u20AC ".concat((offer.price / 100).toFixed(2), " ");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      displayInfoWindow = _useState[0],
      setDisplayInfoWindow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      productLimit = _useState2[0],
      setProductLimit = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      productQuantity = _useState3[0],
      setProductQuantity = _useState3[1];

  function offerUOM(_offer) {
    if (_offer.products.length !== 0 || _offer.groups.length !== 0) {
      return 'το σετ';
    }

    return 'το τεμάχιο';
  }

  function productsLimitReachedWrapper(limit) {
    var quantity = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.getValue */ .UU.getValue();
    (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .productsLimitReached */ .B2)(offer, quantity[offer._id], setDisplayInfoWindow, limit);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var productsQuantities$ = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.subscribe */ .UU.subscribe(function (productQuantities) {
      var _productQuantity = productQuantities[offer._id];
      setProductQuantity(_productQuantity);
    });
    var orderLimitations$ = _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__/* ["default"].subscribe */ .Z.subscribe(function (orderLimitations) {
      var limit = (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .getProductOrderLimit */ .sA)(orderLimitations, offer);
      setProductLimit(limit);
    });
    return function () {
      orderLimitations$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!productLimit) return;
    productsLimitReachedWrapper(productLimit);
  }, [productQuantity, productLimit]);
  var imgSrc = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'image.webSmallThumb', '');
  var searchResultsImage = offer.image.baseUrl + offer.image.primary;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productItem), (_cn = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().offerProductItem), isHomeOffer), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().disabledProduct), disabled), _cn)),
    title: disabled ? DISABLED_OFFER_WARNING : undefined,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .offerLink */ .m9)(offer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productLink),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().layoutSmall),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("header", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().badgeOffer),
              children: offer.webSticker
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("img", {
              loading: "lazy",
              src: imgSrc || searchResultsImage,
              width: "200",
              height: "200",
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productImage),
              alt: offer.name
            }), displayInfoWindow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().infoWindow),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                children: "\u0388\u03C7\u03B5\u03B9\u03C2 \u03C6\u03C4\u03AC\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("main", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
              children: offer.name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().titleDesc),
              title: offer.description,
              children: offer.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
              children: [priceString, offerUOM(offer)]
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btnContainer), (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnContainer)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().priceFooter),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPriceContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPrice),
            children: priceString
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        product: offer,
        productLimit: productLimit,
        quantity: productQuantity,
        isEditable: true,
        removed: disabled
      })]
    })]
  });
}

/***/ }),

/***/ 50778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/objectManipulation.js
var objectManipulation = __webpack_require__(18745);
// EXTERNAL MODULE: ./src/utils/products.js
var utils_products = __webpack_require__(1003);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var index_esm = __webpack_require__(66653);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/components/NoProductsPlaceholder.module.scss
var NoProductsPlaceholder_module = __webpack_require__(2719);
var NoProductsPlaceholder_module_default = /*#__PURE__*/__webpack_require__.n(NoProductsPlaceholder_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NoProductsPlaceholder.jsx






function NoProductsPlaceholder() {
  var _useState = (0,react.useState)(),
      loaderIsVisible = _useState[0],
      setLoaderIsVisible = _useState[1];

  (0,react.useEffect)(function () {
    var loader$ = loader/* default.subscribe */.Z.subscribe(function (_ref) {
      var isVisible = _ref.isVisible;
      setLoaderIsVisible(isVisible);
    });
    return function () {
      loader$.unsubscribe();
    };
  }, []);
  if (loaderIsVisible) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (NoProductsPlaceholder_module_default()).noProductsContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GoSearch */.a4h, {
      className: (NoProductsPlaceholder_module_default()).icon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (NoProductsPlaceholder_module_default()).noProducts,
      children: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03AC\u03BC\u03B5\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1."
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductMenu.module.scss
var ProductMenu_module = __webpack_require__(54820);
var ProductMenu_module_default = /*#__PURE__*/__webpack_require__.n(ProductMenu_module);
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ProductListBanner.jsx







var GA_BANNER_CREATIVE_TAG = 'productsMenu_banner';
function ProductListBanner(_ref) {
  var slug = _ref.slug,
      banners = _ref.banners,
      categories = _ref.categories,
      category = _ref.category,
      isSecondLevelPage = _ref.isSecondLevelPage;

  var _useState = (0,react.useState)(),
      bannerShown = _useState[0],
      setBannerShown = _useState[1];

  var router = (0,next_router.useRouter)();

  function onInView() {
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.name, bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.image, GA_BANNER_CREATIVE_TAG);
    (0,analytics/* viewPromotion */.vk)(promo);
  }

  function onClick() {
    var promo = (0,analytics/* objectToPromoEventTransformer */.ED)(bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.name, bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.image, GA_BANNER_CREATIVE_TAG);
    var redirectUrl = bannerShown === null || bannerShown === void 0 ? void 0 : bannerShown.link;
    (0,analytics/* selectPromotion */.G5)(promo);
    if (!redirectUrl) return;
    var url = new URL(redirectUrl);
    var urlFullPath = last_default()(url.toString().split(url.hostname));
    router.push(urlFullPath);
  }

  function getBannerCategory() {
    if (!banners.length) return;

    if (isSecondLevelPage) {
      var childCategoryBanner = banners.find(function (b) {
        return b.page === category.slug;
      });
      return childCategoryBanner;
    }

    var parentCategory = categories.find(function (_category) {
      return _category.slugAscii === slug[0];
    });
    var parentCategoryBanner = banners.find(function (b) {
      return b.page === parentCategory.slug;
    });
    return parentCategoryBanner;
  }

  (0,react.useEffect)(function () {
    var bannerToShow = getBannerCategory();
    setBannerShown(bannerToShow);
  }, [slug]);
  (0,react.useEffect)(function () {
    if (!bannerShown) return;
    onInView();
  }, [bannerShown]);

  if (slug[0] !== 'offers' && bannerShown && bannerShown.image !== '' && bannerShown.image !== undefined) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: bannerShown.link || '#',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: (ProductMenu_module_default()).bannerLink,
        onClick: onClick,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (ProductMenu_module_default()).bannerImage,
          src: bannerShown.image,
          alt: bannerShown.alt
        })
      })
    });
  }

  return null;
}
// EXTERNAL MODULE: ./src/components/ProductsMenu/ProductListItem.jsx + 1 modules
var ProductListItem = __webpack_require__(57730);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/ProductsMenu/ThirdLevelCategories.module.scss
var ThirdLevelCategories_module = __webpack_require__(66351);
var ThirdLevelCategories_module_default = /*#__PURE__*/__webpack_require__.n(ThirdLevelCategories_module);
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ThirdLevelCategories.jsx





function ThirdLevelCategories(_ref) {
  var _cn;

  var categories = _ref.categories,
      selectedCategoryId = _ref.selectedCategoryId,
      _onClick = _ref.onClick;
  if (!categories.length) return null;
  var categoriesText = {
    el: {
      all: 'Όλα'
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ThirdLevelCategories_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (ThirdLevelCategories_module_default()).button, selectedCategoryId !== '0'), (0,defineProperty/* default */.Z)(_cn, (ThirdLevelCategories_module_default()).buttonSelected, selectedCategoryId === '0'), _cn)),
      type: "button",
      onClick: function onClick() {
        return _onClick('0', true);
      },
      children: categoriesText.el.all
    }), categories.map(function (c) {
      var _cn2;

      if (!c.numberOfProductsToDisplay) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: classnames_default()((_cn2 = {}, (0,defineProperty/* default */.Z)(_cn2, (ThirdLevelCategories_module_default()).button, c._id !== selectedCategoryId), (0,defineProperty/* default */.Z)(_cn2, (ThirdLevelCategories_module_default()).buttonSelected, c._id === selectedCategoryId), _cn2)),
        type: "button",
        onClick: function onClick() {
          return _onClick(c._id, false);
        },
        children: c.name
      }, c._id);
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/ProductsMenu/ProductList.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var ALL_BRANDS_VALUE = '';
function ProductList(_ref) {
  var _products$, _products$$category, _products$$category$c, _products$2, _products$2$category;

  var _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$category = _ref.category,
      category = _ref$category === void 0 ? {} : _ref$category,
      slug = _ref.slug,
      _ref$banners = _ref.banners,
      banners = _ref$banners === void 0 ? [] : _ref$banners,
      categories = _ref.categories,
      showBySelection = _ref.showBySelection,
      isSecondLevelPage = _ref.isSecondLevelPage,
      loading = _ref.loading,
      _ref$categoriesShowin = _ref.categoriesShowing,
      categoriesShowing = _ref$categoriesShowin === void 0 ? [] : _ref$categoriesShowin,
      itemListId = _ref.itemListId,
      itemListName = _ref.itemListName;

  var _useState = (0,react.useState)(''),
      productsShown = _useState[0],
      setProductsShown = _useState[1];

  var _useState2 = (0,react.useState)(ALL_BRANDS_VALUE),
      selectedBrand = _useState2[0],
      setSelectedBrand = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      brandProducts = _useState3[0],
      setBrandProducts = _useState3[1];

  var _useState4 = (0,react.useState)('0'),
      selectedThirdLevelCategoryId = _useState4[0],
      setSelectedThirdLevelCategoryId = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      brandToProductIdsMap = _useState5[0],
      setBrandToProductIdsMap = _useState5[1];

  var router = (0,next_router.useRouter)();
  var productsParentCategory = ((_products$ = products[0]) === null || _products$ === void 0 ? void 0 : (_products$$category = _products$.category) === null || _products$$category === void 0 ? void 0 : (_products$$category$c = _products$$category.categoryTree) === null || _products$$category$c === void 0 ? void 0 : _products$$category$c.parent) || ((_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : (_products$2$category = _products$2.category) === null || _products$2$category === void 0 ? void 0 : _products$2$category._id);
  var offerTitleObject = categoriesShowing.find(function (_category) {
    return _category._id === productsParentCategory;
  });
  var offerTitle = offerTitleObject === null || offerTitleObject === void 0 ? void 0 : offerTitleObject.name;

  function getThirdLevelFromSlugAscii(parentCategory, slugAscii) {
    return parentCategory.subCategories.find(function (thirdLevel) {
      return thirdLevel.slugAscii === slugAscii;
    });
  }

  function addParamsOnURL() {
    var filterId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedThirdLevelCategoryId;
    var brand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectedBrand;

    if (filterId === '0') {
      var _query = _objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('brand', brand));

      router.push({
        pathname: "/categories/".concat(slug.join('/')),
        query: _query
      }, undefined, {
        shallow: true
      });
      setSelectedThirdLevelCategoryId('0');
      return;
    }

    var filter = category.subCategories.find(function (thirdLevelCategory) {
      return thirdLevelCategory._id === filterId;
    });

    var query = _objectSpread(_objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('filter', filter === null || filter === void 0 ? void 0 : filter.slugAscii)), (0,objectManipulation/* getValidObject */.t9)('brand', brand));

    router.push({
      pathname: "/categories/".concat(slug.join('/')),
      query: query
    }, undefined, {
      shallow: true
    });
  }

  var _useState6 = (0,react.useState)([]),
      thirdLvlCategoriesSorted = _useState6[0],
      setThirdLevelCategoriesSorted = _useState6[1];

  function displayThirdLevel(categorySelected) {
    var subCategories = categorySelected.subCategories;
    return subCategories.some(function (c) {
      return c.numberOfProductsToDisplay !== 0;
    });
  }

  function onSelectBrand(_ref2) {
    var value = _ref2.target.value;
    setSelectedBrand(value);
    addParamsOnURL(selectedThirdLevelCategoryId, value);
  }

  function onClickThirdLevelCategory(categoryId, showEverything) {
    if (categoryId === selectedThirdLevelCategoryId) {
      return;
    }

    if (showEverything) {
      setSelectedBrand(ALL_BRANDS_VALUE);
      addParamsOnURL('0', null);
      setSelectedThirdLevelCategoryId('0');
      return;
    }

    setSelectedBrand(ALL_BRANDS_VALUE);
    addParamsOnURL(categoryId, null);
    setSelectedThirdLevelCategoryId(categoryId);
  }

  function getProductsByCategory() {
    if (selectedThirdLevelCategoryId === '0') {
      var _productsByCategory = products;
      return _productsByCategory;
    }

    var productsByCategory = !selectedThirdLevelCategoryId ? products : products.filter(function (p) {
      return p.category._id === selectedThirdLevelCategoryId;
    });
    return productsByCategory;
  }

  function getProductsByBrand(productsByCategory) {
    var productsByBrand = selectedBrand === ALL_BRANDS_VALUE ? productsByCategory : productsByCategory.filter(function (_ref3) {
      var _id = _ref3._id;
      return brandToProductIdsMap[selectedBrand].includes(_id);
    });
    return productsByBrand;
  }

  function setFilterFromURLParams(brandToProductIdMap) {
    var _router$query, _router$query2, _router$query4;

    if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.filter) {
      var selectedThirdLevel = getThirdLevelFromSlugAscii(category, router.query.filter);
      setSelectedThirdLevelCategoryId(selectedThirdLevel._id);
    }

    if (router !== null && router !== void 0 && (_router$query2 = router.query) !== null && _router$query2 !== void 0 && _router$query2.brand && brandToProductIdMap[router.query.brand]) {
      var _router$query3;

      setSelectedBrand(router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.brand);
    } else if (!(router !== null && router !== void 0 && (_router$query4 = router.query) !== null && _router$query4 !== void 0 && _router$query4.brand)) {
      setSelectedBrand('');
    }
  }

  function getFilteredProducts() {
    setProductsShown([]);
    var productsByCategory = getProductsByCategory();
    setBrandProducts(productsByCategory);
    var productsByBrand = getProductsByBrand(productsByCategory);
    var productsByBannerOptions = (0,utils_products/* getSortedProducts */.LB)(productsByBrand, showBySelection);
    setProductsShown(productsByBannerOptions);
  }

  (0,react.useEffect)(function () {
    if (selectedThirdLevelCategoryId) setSelectedThirdLevelCategoryId('0');
  }, [slug]);
  (0,react.useEffect)(function () {
    if (!displayThirdLevel(category)) return;
    var thirdLevelCategories = category.subCategories;
    var sortedCategories = orderBy_default()(thirdLevelCategories, ['categoryIndex', 'divisionCode'], 'asc');
    setThirdLevelCategoriesSorted(sortedCategories);
  }, []);
  (0,react.useEffect)(function () {
    getFilteredProducts();
  }, [selectedBrand, selectedThirdLevelCategoryId, showBySelection, products]);
  (0,react.useEffect)(function () {
    if (slug.length === 2) {
      var brandToProductIdMap = (0,utils_products/* getBrandToProductIdMap */.yH)(brandProducts);
      setBrandToProductIdsMap(brandToProductIdMap);
      setFilterFromURLParams(brandToProductIdMap);
    }
  }, [brandProducts]);
  if (!isSecondLevelPage && productsShown.length === 0) return null;
  var brandNames = Object.keys(brandToProductIdsMap).sort();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ProductMenu_module_default()).categoryContainer,
    children: (productsShown.length !== 0 && slug[0] === 'offers' || slug[0] !== 'offers') && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      "data-cy": "list-of-products",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductMenu_module_default()).listHeader,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: (ProductMenu_module_default()).listTitle,
          children: slug[0] === 'offers' ? offerTitle : category.name
        }), slug.length === 2 && brandNames && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ProductMenu_module_default()).options,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (ProductMenu_module_default()).hideOnSmallScreen,
            children: "\u039C\u03AC\u03C1\u03BA\u03B1: "
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
            className: (ProductMenu_module_default()).selectBrand,
            onChange: onSelectBrand,
            value: selectedBrand,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: ALL_BRANDS_VALUE,
              children: "\u038C\u03BB\u03B1"
            }), brandNames.map(function (b) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: b,
                children: b
              }, b);
            })]
          })]
        })]
      }), slug.length === 2 && displayThirdLevel(category) && /*#__PURE__*/(0,jsx_runtime.jsx)(ThirdLevelCategories, {
        categories: thirdLvlCategoriesSorted,
        selectedCategoryId: selectedThirdLevelCategoryId,
        onClick: onClickThirdLevelCategory
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductMenu_module_default()).bannerContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductListBanner, {
          slug: slug,
          banners: banners,
          categories: categories,
          category: category,
          isSecondLevelPage: isSecondLevelPage
        }), productsShown.length !== 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: productsShown.map(function (p, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListItem/* default */.Z, {
              _product: p,
              positionInList: i + 1,
              itemListId: itemListId,
              itemListName: itemListName
            }, p._id);
          })
        }), productsShown.length === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductMenu_module_default()).centerNoProducts,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NoProductsPlaceholder, {})
        })]
      })]
    })
  });
}

/***/ }),

/***/ 5903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductMenu; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16835);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(246);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _store_deliveryMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34525);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58766);
/* harmony import */ var _store_products__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58345);
/* harmony import */ var _store_productsCollection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67713);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90952);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99700);
/* harmony import */ var _OfferTile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51310);
/* harmony import */ var _ProductList__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50778);
/* harmony import */ var _ProductListItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57730);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(54820);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















function ProductMenu(_ref) {
  var slug = _ref.slug,
      setNumOfProducts = _ref.setNumOfProducts,
      offers = _ref.offers,
      categories = _ref.categories,
      category = _ref.category,
      subCategory = _ref.subCategory,
      productCollections = _ref.productCollections,
      banners = _ref.banners,
      isSticky = _ref.isSticky,
      showBySelection = _ref.showBySelection,
      isSecondLevelPage = _ref.isSecondLevelPage,
      isOfferListPage = _ref.isOfferListPage,
      _ref$staticProducts = _ref.staticProducts,
      staticProducts = _ref$staticProducts === void 0 ? {} : _ref$staticProducts;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      productsShowing = _useState[0],
      setProductsShowing = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      waveSpecialProducts = _useState2[0],
      setWaveSpecialProducts = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      categoriesShowing = _useState3[0],
      setCategoriesShowing = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]),
      offersShowing = _useState4[0],
      setOffersShowing = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      hasMore = _useState5[0],
      setHasMore = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1),
      infiniteScrollIndex = _useState6[0],
      setInfiniteScrollIndex = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(),
      allProductsInCollections = _useState7[0],
      setAllProductsInCollections = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      loading = _useState8[0],
      setLoading = _useState8[1];

  function findWaveProductsCategories(parentCategory, products) {
    var productsInCategory = products.filter(function (p) {
      return parentCategory._id === p.category.categoryTree.root;
    });
    var currentSuperPriceProducts = productsInCategory.filter(function (p) {
      return p.offerType === 'web-only-amount' || p.offerType === 'web-only-percentage';
    });
    setWaveSpecialProducts(currentSuperPriceProducts);
  }

  function findProductsSubcategory(subcategory, _products, isOffers) {
    if (_products.length === 0) {
      return;
    }

    if (subcategory.subCategories.length !== 0) {
      var _productsInCategory = _products.filter(function (p) {
        var _p$category, _p$category$categoryT;

        return subcategory._id === (p === null || p === void 0 ? void 0 : (_p$category = p.category) === null || _p$category === void 0 ? void 0 : (_p$category$categoryT = _p$category.categoryTree) === null || _p$category$categoryT === void 0 ? void 0 : _p$category$categoryT.parent);
      });

      var _productsToShow = isOffers ? _productsInCategory.filter(function (p) {
        return p.offerType !== 'none' && p.offerType !== 'super';
      }) : _productsInCategory;

      setProductsShowing(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, subcategory._id, prevState[subcategory._id] ? [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(prevState[subcategory._id]), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_productsToShow)) : _productsToShow));
      });
    }

    var productsInCategory = _products.filter(function (p) {
      var _p$category2;

      return subcategory._id === (p === null || p === void 0 ? void 0 : (_p$category2 = p.category) === null || _p$category2 === void 0 ? void 0 : _p$category2._id);
    });

    var productsToShow = isOffers ? productsInCategory.filter(function (p) {
      return p.offerType !== 'none' && p.offerType !== 'super';
    }) : productsInCategory;
    setProductsShowing(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, subcategory._id, prevState[subcategory._id] ? [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(prevState[subcategory._id]), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(productsToShow)) : productsToShow));
    });
  }

  function findOffersSubCategory(_offers, subcategory, isRootCategory) {
    var offersToShow = _offers.filter(function (o) {
      var _o$category;

      var categoryTree = o.category.categoryTree;

      if (isRootCategory && (categoryTree === null || categoryTree === void 0 ? void 0 : categoryTree.root) === subcategory._id) {
        return o;
      }

      if (subcategory !== null && subcategory !== void 0 && subcategory.subCategories.length && (categoryTree === null || categoryTree === void 0 ? void 0 : categoryTree.parent) === subcategory._id) {
        return o;
      }

      if ((o === null || o === void 0 ? void 0 : (_o$category = o.category) === null || _o$category === void 0 ? void 0 : _o$category._id) === (subcategory === null || subcategory === void 0 ? void 0 : subcategory._id)) return o;
      return null;
    });

    setOffersShowing(offersToShow);
  }

  function getProductsToShow(currentCategory, products) {
    var isOffers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!currentCategory) return;
    findProductsSubcategory(currentCategory, products, isOffers);
    setLoading(false);
  }

  function loadFunc() {
    if (!categories || !categories.length) return;

    if (categoriesShowing.length && !categoriesShowing[infiniteScrollIndex]) {
      setHasMore(false);
      return;
    }

    if (hasMore && categoriesShowing.length) {
      var _category = categoriesShowing[infiniteScrollIndex];
      var isOffers = slug[0] === 'offers';
      getProductsToShow(_category, allProductsInCollections, isOffers);
      setInfiniteScrollIndex(infiniteScrollIndex + 1);
      _store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.update */ .eH.update(infiniteScrollIndex + 1);
    }
  }

  function initialLoadFunc(index, _allProductsInCollections, allSubCategories) {
    if (!categories || !categories.length) return;

    if (hasMore && allSubCategories.length) {
      var _category = allSubCategories[index];
      var isOffers = slug[0] === 'offers';
      getProductsToShow(_category, _allProductsInCollections, isOffers);
    }
  }

  function scrollToActiveProduct() {
    setTimeout(function () {
      var elemToScrollTo = document.getElementById("pr".concat(_store_products__WEBPACK_IMPORTED_MODULE_7__/* .ActiveProduct.getValue */ .nv.getValue()));

      if (elemToScrollTo) {
        elemToScrollTo.scrollIntoView({
          behavior: 'auto',
          block: 'center'
        });
        _store_products__WEBPACK_IMPORTED_MODULE_7__/* .ActiveProduct.update */ .nv.update('');
        _store_loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"].removeEvent */ .Z.removeEvent('OFFER_SCROLL');
      } else {
        _store_products__WEBPACK_IMPORTED_MODULE_7__/* .ActiveProduct.update */ .nv.update('');
        _store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.update */ .eH.update(1);
      }
    }, 500);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!slug) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;
    if (!categories || !categories.length) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;
    if (!productCollections) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;

    if (slug[0] !== 'offers') {
      var service = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getValue */ .Z.getValue();
      var collectionType = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getCollectionAsNumber */ .Z.getCollectionAsNumber(service) || [];
      var mainCollectionType = collectionType.find(function (c) {
        return c === "900" || c === '751';
      });
      if (!mainCollectionType) return;

      var _allProductsInCollections = _store_productsCollection__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getProductsForCollections */ .Z.getProductsForCollections(collectionType);

      setAllProductsInCollections(_allProductsInCollections);
      setInfiniteScrollIndex(1);
      setProductsShowing({});
      var offersInCollection = offers === null || offers === void 0 ? void 0 : offers.filter(function (o) {
        return o.collectionTypes.includes(parseInt(mainCollectionType));
      });

      var _slug = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(slug, 2),
          categorySlug = _slug[0],
          subCategorySlug = _slug[1];

      if (subCategorySlug) {
        var _tempSubCategory$;

        var tempSubCategory = categories.map(function (c) {
          return c.subCategories.find(function (subC) {
            return subC.slugAscii === subCategorySlug && c.slugAscii === categorySlug;
          });
        }).filter(function (c) {
          return c !== undefined;
        });
        setHasMore(true);
        setCategoriesShowing(tempSubCategory);
        setNumOfProducts((_tempSubCategory$ = tempSubCategory[0]) === null || _tempSubCategory$ === void 0 ? void 0 : _tempSubCategory$.numberOfProductsToDisplay);
        getProductsToShow(tempSubCategory[0], _allProductsInCollections);
        findOffersSubCategory(offersInCollection, tempSubCategory[0], false);
        return;
      }

      var tempCategory = categories.find(function (c) {
        return c.slugAscii === categorySlug;
      });
      var tempSubCategories = tempCategory.subCategories;
      setHasMore(true);
      setCategoriesShowing(tempSubCategories);
      setNumOfProducts(tempCategory === null || tempCategory === void 0 ? void 0 : tempCategory.numberOfProductsToDisplay);
      findWaveProductsCategories(tempCategory, _allProductsInCollections);
      getProductsToShow(tempSubCategories[0], _allProductsInCollections);
      findOffersSubCategory(offersInCollection, tempCategory, true);
      _store_products__WEBPACK_IMPORTED_MODULE_7__/* .ActiveProduct.update */ .nv.update('');
      _store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.update */ .eH.update(1);
    }
  }, [categories, productCollections, slug]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!slug) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;
    if (!categories || !categories.length) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;
    if (!productCollections) return _utils__WEBPACK_IMPORTED_MODULE_15__/* .earlyInUseEffect */ .Z;

    if (slug[0] === 'offers') {
      var service = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getValue */ .Z.getValue();
      var collectionType = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getCollectionAsNumber */ .Z.getCollectionAsNumber(service) || [];
      var mainCollectionType = collectionType.find(function (c) {
        return c === "900" || c === '751';
      });
      if (!mainCollectionType) return;

      var _allProductsInCollections = _store_productsCollection__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getProductsForCollections */ .Z.getProductsForCollections(collectionType);

      setAllProductsInCollections(_allProductsInCollections);
      setProductsShowing({});
      setInfiniteScrollIndex(1);
      var offersInCollection = offers === null || offers === void 0 ? void 0 : offers.filter(function (o) {
        return o.collectionTypes.includes(parseInt(mainCollectionType));
      });

      var _slug2 = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(slug, 1),
          categorySlug = _slug2[0];

      if (categorySlug === 'offers') {
        var allSubCategories = categories.flatMap(function (c) {
          return c.subCategories;
        });
        setHasMore(true);
        setOffersShowing(offersInCollection);
        setCategoriesShowing(allSubCategories);
        getProductsToShow(allSubCategories[0], _allProductsInCollections, true);

        if (_store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.getValue */ .eH.getValue() !== 1 && _store_products__WEBPACK_IMPORTED_MODULE_7__/* .ActiveProduct.getValue */ .nv.getValue() !== '') {
          _store_loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"].addEvent */ .Z.addEvent('OFFER_SCROLL');

          for (var i = 1; i < _store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.getValue */ .eH.getValue(); i++) {
            initialLoadFunc(i, _allProductsInCollections, allSubCategories);
          }

          setInfiniteScrollIndex(_store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.getValue */ .eH.getValue());
          scrollToActiveProduct();
        } else {
          _store_products__WEBPACK_IMPORTED_MODULE_7__/* .CalledProductCategories.update */ .eH.update(1);
        }
      }
    }
  }, [categories, productCollections]);
  var productShowingLength = Object.keys(productsShowing).length;
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    // send analytics view_item_list for every new category added to the viewport
    if (productShowingLength > 0) {
      var lastCategory = Object.keys(productsShowing)[productShowingLength - 1];
      (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_9__/* .viewItemList */ .hW)((0,_utils_analytics__WEBPACK_IMPORTED_MODULE_9__/* .getProductsCartInfo */ .ez)(productsShowing[lastCategory]), {
        item_list_id: category === null || category === void 0 ? void 0 : category._id,
        item_list_name: category === null || category === void 0 ? void 0 : category.name
      });
    }
  }, [productShowingLength]);
  var offersNotEmpty = offersShowing.length !== 0;
  var waveSpecialProductsNotEmpty = waveSpecialProducts.length !== 0; // Code for bots

  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(categoriesShowing)) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("section", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().visibilityHidden),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
        className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listHeader),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("h1", {
          className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listTitle),
          children: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name
        })
      }), Object.values(staticProducts).map(function (productsArray, index) {
        var _category$subCategori, _category$subCategori2;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
          children: [lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(subCategory) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listHeader),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("h2", {
              className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listTitle),
              children: category === null || category === void 0 ? void 0 : (_category$subCategori = category.subCategories) === null || _category$subCategori === void 0 ? void 0 : (_category$subCategori2 = _category$subCategori[index]) === null || _category$subCategori2 === void 0 ? void 0 : _category$subCategori2.name
            })
          }), productsArray.map(function (product, pIndex) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_ProductListItem__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              _product: product,
              itemListName: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
              itemListId: lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(subCategory) ? category === null || category === void 0 ? void 0 : category.name : subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
              positionInList: pIndex + 1
            }, product._id);
          })]
        }, Object.keys(staticProducts)[index]);
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
    className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listContainer),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().infiniteList), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().notSticky), !isSticky)),
      children: [!isOfferListPage && (!isSecondLevelPage && (waveSpecialProductsNotEmpty || offersNotEmpty) || isSecondLevelPage && offersNotEmpty) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listHeader),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("p", {
            className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().listTitle),
            children: "\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BC\u03C6\u03AD\u03C1\u03B5\u03B9"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
          className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_17___default().bannerContainer),
          children: [!isSecondLevelPage && waveSpecialProducts.map(function (product, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_ProductListItem__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              _product: product,
              categories: categories,
              positionInList: index + 1
            }, product._id);
          }), offersShowing.map(function (o) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_OfferTile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
              offer: o
            }, o._id);
          })]
        })]
      }), categoriesShowing && categoriesShowing.length !== 0 && Object.values(productsShowing).length !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)((react_infinite_scroller__WEBPACK_IMPORTED_MODULE_4___default()), {
        threshold: 440 // 440px is the height of a category with 1 row of products
        ,
        hasMore: hasMore // keep it like this until we purge the logic of multiple async calls to local db for products
        ,
        initialLoad: false,
        loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {}, "0"),
        loadMore: loadFunc,
        children: Object.values(productsShowing).map(function (products, i) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_ProductList__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            products: products,
            category: categoriesShowing[i],
            categoriesShowing: categoriesShowing,
            slug: slug,
            banners: banners,
            showBySelection: showBySelection,
            isSecondLevelPage: isSecondLevelPage,
            categories: categories,
            loading: loading,
            itemListId: category === null || category === void 0 ? void 0 : category._id,
            itemListName: category === null || category === void 0 ? void 0 : category.name
          }, categoriesShowing[i]._id);
        })
      })]
    })
  });
}

/***/ }),

/***/ 90952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ earlyInUseEffect; }
/* harmony export */ });
/**
 * Use to early return in useEffect.
 * Usage example `return earlyInUseEffect;`
 */
function earlyInUseEffect() {
  return {};
}

/***/ }),

/***/ 2719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noProductsContainer":"NoProductsPlaceholder_noProductsContainer__iDJPl","icon":"NoProductsPlaceholder_icon__2InZU","noProducts":"NoProductsPlaceholder_noProducts__bihY_"};

/***/ }),

/***/ 92477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerProductItem":"OfferTile_offerProductItem__OLcDJ","btnContainer":"OfferTile_btnContainer__uEgA_"};

/***/ }),

/***/ 54820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"ProductMenu_listContainer__ks2Ns","infiniteList":"ProductMenu_infiniteList__8zE3B","notSticky":"ProductMenu_notSticky__Q5FIP","listTitle":"ProductMenu_listTitle__PxrUW","listHeader":"ProductMenu_listHeader__Crgmj","options":"ProductMenu_options__soiZ6","bannerContainer":"ProductMenu_bannerContainer__V5Oou","categoryContainer":"ProductMenu_categoryContainer__TQ0Xh","selectBrand":"ProductMenu_selectBrand__blXFc","centerNoProducts":"ProductMenu_centerNoProducts__LB64y","bannerLink":"ProductMenu_bannerLink__jJoSR","hideOnSmallScreen":"ProductMenu_hideOnSmallScreen__L_Gdk","visibilityHidden":"ProductMenu_visibilityHidden__6Pghu"};

/***/ }),

/***/ 66351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ThirdLevelCategories_container__N0hPJ","button":"ThirdLevelCategories_button__fmCPq","buttonSelected":"ThirdLevelCategories_buttonSelected__ydz5S"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

}]);